module.exports = __webpack_public_path__ + "img/20220624171912.c5e86192.png";